import "./components/fonts/Tailwind/Tailwind Black.woff2";
import "./components/fonts/Tailwind/Tailwind Light.woff2";
import "./components/fonts/Tailwind/Tailwind Regular.woff2";
import "./components/fonts/chivo/chivo-regular.woff2";
import "./index.css";
import App from "./App";
import React from "react";
import ReactDOM from "react-dom";

//DOM Manipulator
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
